/**
 * LH card colour swatches — The Archive collection grid.
 *
 * Clicking a colour swatch on a product card swaps the card's primary image
 * to that colour's variant image, without navigating.
 *
 * Markup comes from snippets/product-swatch.liquid (context 'product-item',
 * lh_interactive_swatch true). Each button carries the target image:
 *   [data-lh-card-swatch][data-lh-swatch-src][data-lh-swatch-srcset]
 *
 * Delegated from the document so cards added by pagination, filtering, or the
 * Section Rendering API are picked up with no re-init.
 */
(function () {
  'use strict';

  var CARD = '.product-item';
  var PRIMARY = '.product-item__image:not(.product-item__image--two) img';

  function swap(button) {
    var card = button.closest(CARD);
    if (!card) return;

    var img = card.querySelector(PRIMARY);
    if (!img) return;

    var src = button.getAttribute('data-lh-swatch-src');
    var srcset = button.getAttribute('data-lh-swatch-srcset');
    if (!src) return;

    img.src = src;
    if (srcset) {
      img.setAttribute('srcset', srcset);
    } else {
      img.removeAttribute('srcset');
    }

    /* The second image is the hover shot for the original colour, so it would
       contradict the colour just chosen. Suppress it for this card. */
    card.classList.add('product-item--swatch-selected');

    var group = button.closest('.product-swatches-options__list');
    if (group) {
      group.querySelectorAll('[data-lh-card-swatch]').forEach(function (other) {
        var on = other === button;
        other.classList.toggle('is-active', on);
        other.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lh-card-swatch]');
    if (!button) return;

    /* The swatch sits inside the card's image link in some layouts; stop the
       click before it navigates to the product. */
    event.preventDefault();
    event.stopPropagation();

    swap(button);
  });

  /* Enter/Space already fire click on a <button>; this only guards against a
     parent link hijacking the keyboard activation. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var button = event.target.closest('[data-lh-card-swatch]');
    if (button) event.stopPropagation();
  });
})();
